import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Box, Flex } from 'rebass/styled-components';
import { useSelector } from 'react-redux';
import { MainLayoutMenu } from '../../molecules/mainLayoutMenu';
import { ImpersonationBanner } from '../../molecules/impersonationBanner';

const MainLayout = ({ children, containerProps }) => {
  const isMenuOpen = useSelector((state) => state.mainMenu.isOpen);

  // Initialize menu width from localStorage immediately to prevent flicker
  const getInitialWidth = () => {
    const savedWidth = localStorage.getItem('sidebar-width');
    if (savedWidth) {
      const parsedWidth = parseInt(savedWidth, 10);
      if (!Number.isNaN(parsedWidth) && parsedWidth >= 200 && parsedWidth <= 440) {
        return parsedWidth;
      }
    }
    return 240;
  };

  const [menuWidth, setMenuWidth] = useState(getInitialWidth);
  const contentRef = useRef(null);

  return (
    <Flex sx={{ height: '100%' }}>
      <MainLayoutMenu width={menuWidth} setMenuWidth={setMenuWidth} contentRef={contentRef} />
      <Box
        ref={contentRef}
        ml={isMenuOpen ? [0, 0, menuWidth] : 0}
        flex="1"
        sx={{
          transition: ['none', 'none', 'margin-left 0.15s ease-in-out'],
        }}
      >
        <ImpersonationBanner />
        <Flex minHeight="calc(100vh - 64px)" pb="40px" flexDirection="column" {...containerProps}>
          {children}
        </Flex>
      </Box>
    </Flex>
  );
};

MainLayout.propTypes = {
  children: PropTypes.node.isRequired,
  containerProps: PropTypes.object,
};

MainLayout.defaultProps = {
  containerProps: {},
};

export default MainLayout;
